import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  CardWrapper,
  CardHeader,
  HeaderContent,
  ShowMoreButton,
  Divider,
  KeyStatsContainer,
  StatBadge,
  NoDataMessage,
  SkeletonWrapper,
  SkeletonItem,
  SkeletonBlock,
} from "./KeyStats.styles";
import { KeyStatsModal } from "shared/StrategyOverview/Components/KeyStatsModal";
import { Text } from "style/v2/components/Typography";
import { HIDDEN_KEY_STATS } from "utils/constants";

// Example icons
import { LineChartUpIcon } from "assets/icons";

const getFormattedValue = (value) => {
  if (value === "True") return "Yes";
  if (value === "False") return "No";
  return value;
};

const ICON_MAP = {
  Equity: LineChartUpIcon,
};

const KeyStats = ({ stats = [], isLoading }) => {
  const [showKeyStatsModal, setShowKeyStatsModal] = useState(false);

  const toggleViewMoreModal = () => {
    setShowKeyStatsModal((prev) => !prev);
  };

  const visibleStats = (stats || []).filter(
    (data) => !HIDDEN_KEY_STATS.includes(data?.name)
  );

  return (
    <CardWrapper>
      <CardHeader>
        <HeaderContent>
          <Text variant="cardHeading" weight="500">
            Key Metrics
          </Text>
          {visibleStats?.length > 0 && (
            <ShowMoreButton onClick={toggleViewMoreModal}>
              Show more
            </ShowMoreButton>
          )}
        </HeaderContent>
        <Divider />
      </CardHeader>

      {isLoading ? (
        <KeyStatsContainer>
          <SkeletonWrapper>
            {[...Array(6)].map((_, i) => (
              <SkeletonItem key={i}>
                <SkeletonBlock width="60%" height="12px" />
                <SkeletonBlock width="40%" height="14px" />
              </SkeletonItem>
            ))}
          </SkeletonWrapper>
        </KeyStatsContainer>
      ) : visibleStats?.length > 0 ? (
        <KeyStatsContainer>
          {visibleStats.slice(0, 8).map((data, i) => {
            const Icon = ICON_MAP[data?.value] || null;

            return (
              <div key={i}>
                <Text variant="label" color="muted" as="p" mb="4px">
                  {data.name}
                </Text>

                {["Equity"].includes(data?.value) ? (
                  <StatBadge>
                    {Icon && <img src={Icon} alt="" />}
                    {data?.value}
                  </StatBadge>
                ) : (
                  <Text variant="cardHeading" weight="500" color="secondary">
                    {getFormattedValue(data?.value)}
                  </Text>
                )}
              </div>
            );
          })}
        </KeyStatsContainer>
      ) : (
        <NoDataMessage>No Key Statistics found</NoDataMessage>
      )}

      {showKeyStatsModal && (
        <KeyStatsModal
          show={showKeyStatsModal}
          onHide={toggleViewMoreModal}
          stats={visibleStats}
          getFormattedValue={getFormattedValue}
        />
      )}
    </CardWrapper>
  );
};

export default KeyStats;

KeyStats.propTypes = {
  stats: PropTypes.array,
  isLoading: PropTypes.bool,
};
